import FormErrors from "@/components/FormErrors/FormErrors";
import { Editor, EditorContent } from "tiptap";
import { JSConn } from "@/utilities/js-conn";
import uuidv4 from "uuid/v4";

export default {
  name: "workOrderInstructionEditForm",
  props: {
    workOrderInstructionId: String,
  },
  components: {
    EditorContent,
    FormErrors,
  },
  data() {
    return {
      instruction: {
        content_json: {},
        description: "Basic Instructions",
      },
      editor: null,
      hasInstructionErrors: false,
      instructionErrors: [],
    };
  },
  created() {
    // get the data from the store
    if (this.workOrderInstructionId === "new") {
      this.instruction = {
        id: uuidv4(),
        content_json: {},
        description: "Basic instructions",
        work_order_id: this.workOrder.id,
      };
    } else {
      const woInstruction = this.$store.getters.workOrderInstructionById(
        this.workOrderInstructionId,
      );
      this.instruction = {
        id: woInstruction.id,
        content_json: woInstruction.content_json,
        description: woInstruction.description,
        work_order_id: this.workOrder.id,
      };
    }
  },
  mounted() {
    this.editor = new Editor({
      autoFocus: true,
      content: this.instruction.content_json,
    });
  },
  beforeDestroy() {
    // always destroy the instance
    this.editor.destroy();
  },
  methods: {
    submitInstruction() {
      const jsConn = new JSConn();

      this.instruction.content_json = this.editor.getJSON();

      let storeDispatch;

      if (this.workOrderInstructionId === "new") {
        storeDispatch = "createWorkOrderInstruction";
      } else {
        storeDispatch = "updateWorkOrderInstruction";
      }

      jsConn.formParams = this.instruction;

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          this.$emit("instructionsChanged");
          // move to the list of instructions
          this.$router.push({
            name: "workOrderInstructions",
          });
        })
        .catch(jsConn => {
          this.hasInstructionErrors = true;
          this.instructionErrors = jsConn.error["response"]["data"];
        });
    },
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
  },
};
